import { Component, Input, inject } from '@angular/core'
import { ProductCustomField } from '../../types/product-custom-fields'
import { TranslationService } from '../../services/translation.service'

@Component({
  selector: 'app-product-custom-fields',
  templateUrl: './product-custom-fields.component.html',
  styleUrl: './product-custom-fields.component.scss',
})
export class ProductCustomFieldsComponent {
  /**
   * Attributes shown as label/value pairs; the section is hidden when none are supplied.
   * @input {ProductCustomField[] | null | undefined} fields Product attributes to display.
   */
  @Input() fields?: ProductCustomField[] | null
  /**
   * Overrides the default translated Custom fields heading for the current page.
   * @input {string | undefined} heading Optional section heading from the parent component.
   */
  @Input() heading?: string
  t = inject(TranslationService)
}
